import type { DisplayCollectionDTO, LazyArtworkDTO } from "./types";

/**
 * The anonymous slice of the API, used by the public gallery route.
 *
 * It deliberately does not go through `HttpClient`: that class attaches the
 * bearer token and retries through `/auth/refresh` on a 401, which would send a
 * visitor with no session into a refresh loop. These three endpoints are
 * `@AnonymousAllowed` and take a plain fetch.
 */
export class PublicClient {
  constructor(private readonly basePath = "/api/2.0") {}

  async getDisplayCollectionByUUID(uuid: string): Promise<DisplayCollectionDTO | null> {
    const response = await fetch(`${this.basePath}/public/display/collection/uuid/${uuid}`);
    if (response.status === 404) return null;
    if (!response.ok) throw new Error(`Collection lookup failed (${response.status})`);
    const text = await response.text();
    return text ? (JSON.parse(text) as DisplayCollectionDTO) : null;
  }

  async getLazyArtworksByIds(ids: number[]): Promise<LazyArtworkDTO[]> {
    if (ids.length === 0) return [];
    const response = await fetch(
      `${this.basePath}/public/lazy/artwork?ids=${ids.map(String).join(",")}`,
    );
    if (!response.ok) return [];
    const text = await response.text();
    return text ? (JSON.parse(text) as LazyArtworkDTO[]) : [];
  }
}
